import {
  useContext,
} from 'react';
import {Context} from '../contexts/WordList';
import {createWord} from '../helpers/localApi';

export function useAddWord(wordEn, wordFa, transliteration) {
  const [state, dispatch] = useContext(Context);
  const {language} = state;

  const addWord = async (wordEn, wordFa, transliteration, options = {}) => {
    if (wordEn !== undefined && wordFa !== undefined) {
      try {
        const newWord = await createWord({
          language,
          wordEn,
          wordFa,
          transliteration,
          sentences: options.sentences,
          sourceUrl: options.sourceUrl,
          sourceTitle: options.sourceTitle,
        });

        dispatch({type: 'ADD_WORD', payload: newWord});
        return newWord;
      } catch (error) {
        console.error('Error adding word: ', error);
        throw error;
      }
    }

    return null;
  };

  return {addWord};
};
